module.exports = __webpack_public_path__ + "img/noper.edecffd5.png";